import React from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import NotificationSettings from './Detail/NotificationSettings';
import NoData from '../CustomizedComponents/DisplayData/NoData';
import LoadingIndicator from '../LoadingIndicator/LoadingIndicator';
import styled from 'styled-components';

const LoadingWrapper = styled.div`
  height: 2px;
`;

const NotificationSettingsWrapper = (
  { id, notification, loading, error, handlers },
) => {
  const {
    productLoading,
  } = notification;
  const noData = 'app.dataTable.body.noData';
  const showNothingToDisplay = Object.keys(notification).length === 0 && !loading && !error && id !== 'new';
  const showError = !!error && id !== 'new';
  const showBody = (notification || id === 'new') && !error && !loading;

  return (
    <>
      {showNothingToDisplay && <NoData><FormattedMessage id={noData} /></NoData>}
      {showError && <NoData><FormattedMessage id={noData} /></NoData>}
      { (loading || productLoading )&&
        <LoadingWrapper><LoadingIndicator /></LoadingWrapper>
      }
      {showBody &&
      <NotificationSettings
        id={id}
        notification={notification}
        handlers={handlers}
      />}
    </>
  );
};

NotificationSettingsWrapper.propTypes = {
  id: PropTypes.any,
  notification: PropTypes.object,
  loading: PropTypes.bool,
  error: PropTypes.string,
  handlers: PropTypes.object,
};


export default NotificationSettingsWrapper;
